import type { TRPC } from './types';
import type { Locale } from '@/lib/enums/locale.enum';

export const certificateKeys = {
  byCompany: (trpc: TRPC) => trpc.certificates.byCompany.pathKey(),
};

type ByCompanyArgs = {
  trpc: TRPC;
  registrationCode: string;
  locale: Locale;
};

export const byCompanyQueryOptions = ({ trpc, registrationCode, locale }: ByCompanyArgs) =>
  trpc.certificates.byCompany.queryOptions(
    { registrationCode, locale },
    {
      staleTime: 5 * 60 * 1000,
    },
  );
